module.exports = __webpack_public_path__ + "static/media/video-3.8f67e682.jpg";